import { Button, Stack } from '@mui/material'
import React from 'react'
import { getValidLinkedSourceTypes, getValidSourceTypes } from '../../../utils/issues/sourceTypes'
import { intersection } from '../shared/source-fields/utils'

export const SourceTypeButtons = ({ entityType, selectedSourceType, setSelectedSourceType }) => {
    const validLinkedSourceTypes = getValidLinkedSourceTypes()
    const sourceTypes = entityType
        ? intersection(validLinkedSourceTypes, getValidSourceTypes(entityType))
        : getValidLinkedSourceTypes()
    const rows = [sourceTypes.slice(0, 4), sourceTypes.slice(4)]

    return (
        <Stack sx={{ mt: 2 }} direction='column' spacing={2}>
            {rows.map((row, i) => (
                <Stack key={i} direction='row' spacing={2}>
                    {row.map((st) => (
                        <Button
                            key={st}
                            variant={st === selectedSourceType ? 'contained' : 'outlined'}
                            color={st === selectedSourceType ? 'secondary' : 'primary'}
                            size='small'
                            onClick={() => setSelectedSourceType(st)}
                        >
                            {st}
                        </Button>
                    ))}
                </Stack>
            ))}
        </Stack>
    )
}
